import { Component, Inject, Input, OnInit, Output, EventEmitter, ChangeDetectorRef} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import {
  MediaMatcher
} from '@angular/cdk/layout';

/**
 * Services
 */
import { CrudService } from '@services/laravel/crud.service';
import { AuthenticationService } from '@services/laravel/authentication.service';
import { environment } from '@env/environment';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { CommitmentTermModalComponent } from '../commitment-term-modal/commitment-term-modal.component';
import { MAIN_COMPONENT_CONTEXT, MainComponentContext } from '@shared/tokens/main-component-context.token';

import { MatCard } from '@angular/material/card';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatError } from '@angular/material/input';

@Component({
    standalone: true,
    selector: 'ntm-menu-sidenav',
    animations: [
        trigger('firstAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)', opacity: 0 }),
                animate('200ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', 'opacity': 1 }),
                animate('200ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }))
            ])
        ]),
        trigger('myAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)', opacity: 0 }),
                animate('200ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', 'opacity': 1 }),
                animate('200ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }))
            ])
        ]),
        trigger('buttonAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)', opacity: 0 }),
                animate('200ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', 'opacity': 1 }),
                animate('200ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }))
            ])
        ])
    ],
    templateUrl: './menu-sidenav.component.html',
    styleUrls: ['./menu-sidenav.component.scss'],
    imports: [MatCard, MatTooltip, MatIconButton, RouterLink, RouterLinkActive, MatIcon, MatButton, MatError]
})
export class MenuSidenavComponent implements OnInit {
  private _mobileQueryListener: () => void;
  @Input() params;
  @Input() openClose;

  @Output()
  eventToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  errors = [];
  mdIconClose: string;
  mdIconOpen: string;
  mdIconSettings: string;
  menuBackground: boolean;
  toggle = false;
  userData: any;
  applicationsArray: any;
  user: any;
  bkp_token: any;
  userName: string;
  width: number;
  routeCount: any = 0;
  public mobileQuery: MediaQueryList;
  public options: any;
  public selectedApplication: any;
  blockedByCommitmentTerm = false;
  groupedMenuSettings: Array<{ category: string; items: any[] }> = [];

  constructor(
    @Inject(MAIN_COMPONENT_CONTEXT) public mainComponent: MainComponentContext,
    private dialog: MatDialog,
    private _crud: CrudService,
    private _auth: AuthenticationService,
    private router: Router,
    public media: MediaMatcher,
    public changeDetectorRef: ChangeDetectorRef
  ) {

    if (sessionStorage.getItem('bkp_access_token')) {
      this.bkp_token = true;
    } else {
      this.bkp_token = false;
    }
    this.openClose = false;

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.matches ? this.openClose = false : this.openClose = true;

    this
      .mobileQuery
      .addListener(this._mobileQueryListener);

    this.options = {
      fixed: 'fixed', // Define the sidenav style, possible values are 'fixed' and 'Non-fixed'
      opened: !this.mobileQuery.matches, // Possible values are true or false
      mode: 'side', // Define the sidenav mode, possible values are push, side and over
      top: 0, // Css 'top' from sidenav
      bottom: 0, // Css 'bottom' from sidenav
      userCard: true
    };
  }

  ngOnInit() {
    // this.listApplications();
    // this.mainComponent.updateApplicationIndicator();
    // this.setSideNav();
    this.readSelectedApplication();
    this.setGroupedMenuSettings();
  }

  ngOnChanges() {
    this.listApplications();
    // this.setSideNav();
    this.readSelectedApplication();
    this.setGroupedMenuSettings();
  }

  setGroupedMenuSettings(): void {
    const menuSettings = this.params?.menuSettings;

    if (!Array.isArray(menuSettings)) {
      this.groupedMenuSettings = [];
      return;
    }

    this.groupedMenuSettings = menuSettings.reduce((groups, item) => {
      const category = item?.categoria ?? 'Menu';
      const group = groups.find(current => current.category === category);

      if (group) {
        group.items.push(item);
      } else {
        groups.push({ category, items: [item] });
      }

      return groups;
    }, [] as Array<{ category: string; items: any[] }>);
  }

  setSideNav() {
    if (this.params && this.user.application) {
      for (let i = 0; i < this.user.application.profiles.length; i++) {
          const verificationProfile = this.user.application.profiles.filter(
            el => el.access_profile.description == this.user.application.profiles[i].access_profile.description
          );

          const firstProfile = this.user.application.profiles[this.user.application.profiles.indexOf(verificationProfile[0])];
          const school = this.user.application.profiles[i].school;
          const course = this.user.application.profiles[i].course;
          const profileIndexFromOriginalArray = this.user.application.profiles.indexOf(this.user.application.profiles[i]);
          const repeatedProfileIndexFromOriginalArray = this.user.application.profiles.indexOf(verificationProfile[0]);

          if (verificationProfile.length > 1) {
            if (school) {
              if (firstProfile.access_profile.tip == undefined) {
                firstProfile.access_profile.tip = school.description;
              } else {
                firstProfile.access_profile.tip += school.description;
              }
            }

            if (course && firstProfile.access_profile.tip != undefined) {
              firstProfile.access_profile.tip += ' - ' + course.description + '\n\n';
            } else if (course && firstProfile.access_profile.tip == undefined) {
              firstProfile.access_profile.tip += course.description + '\n\n';
            }

            if (profileIndexFromOriginalArray != repeatedProfileIndexFromOriginalArray) {
              this.user.application.profiles.splice(profileIndexFromOriginalArray, 1);
              i--;
            }

          } else {
            // let profileTip = this.user.application.profiles[i].access_profile.tip;
            if (school) {
              this.user.application.profiles[i].access_profile.tip = school.description;
            }

            if (course && this.user.application.profiles[i].access_profile.tip != undefined) {
              this.user.application.profiles[i].access_profile.tip += ' - ' + course.description;
            } else if (course && this.user.application.profiles[i].access_profile.tip == undefined) {
              this.user.application.profiles[i].access_profile.tip = course.description;
            }
          }
        }

      if (!this.params.mdIconOpen) {
        this.mdIconOpen = 'menu';
      } else {
        this.mdIconOpen = this.params.mdIconOpen;
      }


      if (!this.params.mdIconClose) {
        this.mdIconClose = 'menu';
      } else {
        this.mdIconClose = this.params.mdIconClose;
      }

      if (this.params.paramsToSettings) {
        if (!this.params.paramsToSettings.mdIcon || !this.params.paramsToSettings.route) {
          this.errors.push({
            cod: 'bm-lo-02',
            message: 'Definir rota e ícone do ítem setting ({paramsToSettings: [{mdIcon: string, route: Array<string>}]})'
          });
        }
      }
    } else {
      this.errors.push({
        cod: 'p-01',
        message: 'Definir parâmetros mínimos do componente'
      });
    }
  }

  listApplications = () => {
    this._crud.get('user').then(res => {
      this.user = res;

      if (this.user.is_first_access == 1) {
        this.router.navigate(['/main/first-access']);
      }

      const arrayName = this.user.name.split(' ');
      if (arrayName.length > 1) { this.user.name = arrayName[0] + ' ' + arrayName[arrayName.length - 1]; }

      this.user.avatar_path =  environment.urlToAvatar + 'storage/user-images/' + this.user.avatar_path;

      if (this.router.url.indexOf('select-application') != -1 && res['application']) {
        if (res['events'].length > 0) {
          if (this.mainComponent.getTermConfirmation()) {
            this.mainComponent.onSelectApplication?.(res['events'], res['application']);
          } else {
            this.openCommitmentTerm(this.mainComponent.getCurrentApplication());
          }
        }
      } else {

      }
      this.setSideNav();
      this.applicationsArray = res['events'];
      this.mainComponent.setApplicationArray(this.applicationsArray);
      this.mainComponent.updateApplicationIndicator();

      sessionStorage.setItem('user_id', this.user.id);
      sessionStorage.setItem('user', JSON.stringify(this.user));
    });
  }

  onChangeApplication(application) {
    this.mainComponent.onChangeApplication(application);
  }

  readSelectedApplication() {
    if (sessionStorage.getItem('application') && JSON.parse(sessionStorage.getItem('application')) != null) {
      this.selectedApplication = JSON.parse(sessionStorage.getItem('application'));
    }
  }

  help = () => {
    this.router.navigate(this.params.paramsToHelp.route);
    if (this.params.windowSizeReference) {
      if (this.width < this.params.windowSizeReference) {
        this.openClose = !this.openClose;
        this.eventToggle.emit(this.openClose);
      }
    } else {
      this.openClose = !this.openClose;
      this.eventToggle.emit(this.openClose);
    }
  }

  onMenuRoute = (route) => {
    this.router.navigate([route]);

    if (this.params.windowSizeReference) {
      if (this.width < this.params.windowSizeReference) {
        this.openClose = !this.openClose;
        this.eventToggle.emit(this.openClose);
      }
    } else {
      this.openClose = !this.openClose;
      this.eventToggle.emit(this.openClose);
    }
  }

  onToggle = (event) => {
    this.openClose = !this.openClose;
    this.eventToggle.emit(this.openClose);
  }

  settings = () => {
    this.router.navigate(this.params.paramsToSettings.route);
    if (this.params.windowSizeReference) {
      if (this.width < this.params.windowSizeReference) {
        this.openClose = !this.openClose;
        this.eventToggle.emit(this.openClose);
      }
    } else {
      this.openClose = !this.openClose;
      this.eventToggle.emit(this.openClose);
    }
  }

  fixAvatar() {
    this.user.avatar_path = 'data:image/jpeg;base64,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';
  }

  setBkpToken(value) {
    this.bkp_token = value;
  }

  backToAdmin() {
    this.bkp_token = false;
    sessionStorage.removeItem('bkp_access_token');

    this.router.navigate(['/main/dashboard']);
  }

  logout = () => {
    let params;
    params = {
      navigateTo: '/'
    };

    this._auth.logout();
    this.router.navigateByUrl(params.navigateTo);
  }

  openCommitmentTerm = (application_id) => {
    const dialogRef = this.dialog.open(CommitmentTermModalComponent, {
      width: '85%',
      height: 'auto',
      data: {},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onChangeApplication({ id: application_id });
      }
    });
  }
}
